export default __webpack_public_path__ + "static/paint-spray-secondary-17dea1ee134fc498ed2da82721d763cf.webp";